import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthorizationLogsComponent } from './authorizationlogs.component';
import { AuthorizationLogsRoutingModule } from './authorizationlogs-routing.module';
@NgModule({
  declarations: [AuthorizationLogsComponent],
  
  imports: [
    CommonModule,
    GridModule,
    AuthorizationLogsRoutingModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    MyDatePickerModule
  ],
  providers:[PageService,
    SortService,
    ResizeService,
    FilterService,ColumnChooserService]
})
export class AuthorizationLogsModule { }
